import { createContext as e, useContext as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/context/ConfigEditorContext.tsx
var r = e(null), i = ({ children: e, routeBasePath: t, readonly: i = !1, configuration: a, metadata: o, showTriggers: s = !1, referenceData: c = {}, allVariables: l, onSave: u, onDelete: d, onPush: f, onShowLinkedGateways: p, onNavigateToOriginal: m, breadcrumbs: h, externalSchemas: g }) => {
	let _ = {
		routeBasePath: t,
		readonly: i,
		configuration: a,
		metadata: o,
		showTriggers: s,
		referenceData: c,
		allVariables: l,
		onSave: u,
		onDelete: d,
		onPush: f,
		onShowLinkedGateways: p,
		onNavigateToOriginal: m,
		breadcrumbs: h,
		externalSchemas: g,
		isDirty: !1
	};
	return /* @__PURE__ */ n(r.Provider, {
		value: _,
		children: e
	});
}, a = () => {
	let e = t(r);
	if (!e) throw Error("useConfigEditor must be used within a ConfigEditorProvider");
	return e;
};
//#endregion
export { a as n, i as t };

//# sourceMappingURL=ConfigEditorContext-CoIs6lgL.js.map